import { createContext } from "react";
interface UserInformation {
  token: string;
  fullName: string;
  mobile: number;
  userRoll: any[];
  id: any;
}
interface AuthenticationInterface {
  userInfo: UserInformation;
  isLogged: boolean;
  isChecked: boolean;
  login: (
    token: string,
    fullName: string,
    mobile: number,
    userRoll: any[],
    id: any
  ) => void;
  logout: () => void;
}

const AuthenticationContext = createContext<AuthenticationInterface>({
  userInfo: {
    token: "",
    fullName: "",
    mobile: 0,
    userRoll: [],
    id: null,
  },
  isLogged: false,
  isChecked: false,
  login: () => {},
  logout: () => {},
});
export default AuthenticationContext;
// account types:
// 1: customer
// 2: tour leader
// 3:حسابدار
// 4:کانتر فروش
// 5:مدیریت کل
// status = -10 suspend
